import React from "react";

/**
 * Real brand assets uploaded by the customer.
 * MASCOT_URL — house character only (no wordmark)
 * LOGO_URL   — full logo with "Faithfully Clean / Pressure Washing & Exterior Cleaning"
 */
export const MASCOT_URL = "/brand/mascot.png";
export const LOGO_URL = "/brand/logo.png";

/**
 * Mascot image. `talking` adds a subtle mouth bob to fake "speaking" while the chat
 * assistant is generating a response.
 */
const Mascot = ({ className = "w-72 h-72", talking = false, variant = "mascot" }) => {
  const src = variant === "logo" ? LOGO_URL : MASCOT_URL;
  return (
    <img
      src={src}
      alt={variant === "logo" ? "Faithfully Clean logo" : "Faithfully Clean mascot"}
      className={`${className} object-contain ${talking ? "mascot-talking" : ""}`}
      draggable={false}
      data-testid={variant === "logo" ? "brand-logo-img" : "brand-mascot-img"}
    />
  );
};

export default Mascot;
